import { Paper } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import ActionsTable from './ActionsTable';

interface Props {
    accountId: string;
    region: string;
    approvalRecord: any;
    deploymentRecipe: any[];
}

function ActionsPanel(props: Props) {
    const [actions, setActions] = useState([]);
    const { approvalRecord, deploymentRecipe, accountId, region } = props;

    useEffect(() => {
        const selectedActions = approvalRecord.SelectedActions;
        const actions = deploymentRecipe.map(action => {
            return {
                actionName: action.ActionName,
                deckName: action.DeckName,
                deploymentName: action.DeploymentName,
                version: action.Version,
                selected: !selectedActions || selectedActions.includes(action.ActionName)
            };
        });

        setActions(actions);
    }, [approvalRecord, deploymentRecipe]);

    return (
        <Paper>
            <ActionsTable actions={actions} accountId={accountId} region={region} />
        </Paper>
    );
};

export default ActionsPanel;
